/** NV toggle label beside TCV (wraps via CSS); also used as the switch aria-label. */
export const FRAME_CONTRACT_OPPORTUNITY_TOGGLE_LABEL = 'NV - Opportunity for new frame contract';

/** Deal-size filter dropdown (matches {@link DEAL_SIZES} NV entry). */
export const FRAME_CONTRACT_OPPORTUNITY_FILTER_LABEL = 'NV — new frame contract';
